import { type DestinationStream, pino, type LoggerOptions, type Logger as PinoLogger } from 'pino';
import {
  type LambdaContext,
  type LambdaEvent,
  lambdaRequestTracker,
  pinoLambdaDestination,
  StructuredLogFormatter,
} from 'pino-lambda';

export type Logger = PinoLogger;

export const getLogger = (options: LoggerOptions = {}, dest?: DestinationStream) =>
  pino(
    {
      ...options,
      level: options.level || process.env['LOG_LEVEL'] || 'info',
      base: {
        ...((process.env['DATAPLANE_VERSION'] || process.env['DPQA_CLOUD_VERSION']) && {
          version: process.env['DATAPLANE_VERSION'] || process.env['DPQA_CLOUD_VERSION'],
        }),
        ...options.base,
      },
    },
    dest || pinoLambdaDestination({
      formatter: new StructuredLogFormatter(), // to ensure JSON format
    }),
  );

export const withRequest = (event: LambdaEvent, ctx: LambdaContext) => {
  const tracker = lambdaRequestTracker({
    requestMixin: (e: LambdaEvent, _ctx: LambdaContext): Record<string, string | undefined> => ({
      tenant: e['requestContext']?.['authorizer']?.['tenant'],
      user: e['requestContext']?.['authorizer']?.['userId'],
      functionName: process.env['AWS_LAMBDA_FUNCTION_NAME'],
    }),
  });

  tracker(event, ctx);
};
